import { SupportedLanguages } from '../../i18n/constants';
import { EVENT_TRIGGER_ACTION_TYPE } from '../event-trigger/types';

export const SUPPORTED_ACTION_TYPES = new Set<EVENT_TRIGGER_ACTION_TYPE>([EVENT_TRIGGER_ACTION_TYPE.COIN_TUTORIAL]);
export const FINISH_COIN_TUTORIAL_TIMEOUT_MS = 3000;
export const RIVE_COIN_TOGGLE_LOCALISATION_MAP = new Map<SupportedLanguages, number>([
  [SupportedLanguages.EN, 1],
  [SupportedLanguages.DE, 3],
]);
